var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.draggable ? _c('Draggable', {
    staticClass: "omnistock omni-checkboxes",
    class: {
      grid: _vm.grid,
      'no-grid': !_vm.grid
    },
    attrs: {
      "options": {
        animation: 150
      },
      "group": _vm.randomGroupId,
      "disabled": _vm.disabled
    },
    on: {
      "end": _vm.emitNewValues
    },
    model: {
      value: _vm.internalOptions,
      callback: function ($$v) {
        _vm.internalOptions = $$v;
      },
      expression: "internalOptions"
    }
  }, _vm._l(_vm.internalOptions, function (option, index) {
    return _c('div', {
      key: option.value,
      staticClass: "checkbox-container draggable"
    }, [_c('FontAwesomeIcon', {
      staticClass: "grip-icon",
      attrs: {
        "icon": "grip-lines-vertical"
      }
    }), !_vm.hideCheckboxes ? _c('BFormCheckbox', {
      attrs: {
        "value": option.value,
        "disabled": option.disabled || _vm.disabled
      },
      model: {
        value: _vm.internalPicked,
        callback: function ($$v) {
          _vm.internalPicked = $$v;
        },
        expression: "internalPicked"
      }
    }, [_vm.prependNumbers ? [_vm._v(" " + _vm._s(index + 1) + ".  ")] : _vm._e(), _c('span', {
      domProps: {
        "innerHTML": _vm._s(option.text)
      }
    })], 2) : _c('span', [_vm.prependNumbers ? [_vm._v(" " + _vm._s(index + 1) + ".  ")] : _vm._e(), _c('span', {
      domProps: {
        "innerHTML": _vm._s(option.text)
      }
    })], 2)], 1);
  }), 0) : _c('div', {
    staticClass: "omnistock omni-checkboxes"
  }, _vm._l(_vm.options, function (option) {
    return _c('div', {
      key: option.value,
      staticClass: "checkbox-container"
    }, [!_vm.hideCheckboxes ? _c('BFormCheckbox', {
      attrs: {
        "value": option.value,
        "disabled": option.disabled || _vm.disabled
      },
      model: {
        value: _vm.internalPicked,
        callback: function ($$v) {
          _vm.internalPicked = $$v;
        },
        expression: "internalPicked"
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(option.text)
      }
    })]) : _c('span', {
      domProps: {
        "innerHTML": _vm._s(option.text)
      }
    })], 1);
  }), 0);

}
var staticRenderFns = []

export { render, staticRenderFns }